import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Switch } from "antd";

import {
  togglePressEnterToSendMessage,
  toggleDynamicMessageFilter,
  toggleAlwaysOpenNewMessages,
  toggleReceiveEmailNotifications,
  toggleReceiveMentionEmailNotifications,
} from "../../store/actions/general-settings";

import UserService from "../../services/user";

import "./GeneralSettings.scss";

class GeneralSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.toggleDynamicMessageFilter =
      this.toggleDynamicMessageFilter.bind(this);
    this.toggleAlwaysOpenNewMessages =
      this.toggleAlwaysOpenNewMessages.bind(this);
    this.togglePressEnterToSendMessage =
      this.togglePressEnterToSendMessage.bind(this);
    this.toggleReceiveEmailNotifications =
      this.toggleReceiveEmailNotifications.bind(this);
    this.toggleReceiveMentionEmailNotifications =
      this.toggleReceiveMentionEmailNotifications.bind(this);
  }

  toggleDynamicMessageFilter() {
    this.props.toggleDynamicMessageFilter();

    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: !this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      alwaysNotifyByEmail: this.props.options.receiveEmailNotifications,
      notifyOnMentionOnly: this.props.options.receiveMentionEmailNotifications,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
  }

  toggleAlwaysOpenNewMessages() {
    this.props.toggleAlwaysOpenNewMessages();

    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: !this.props.options.alwaysOpenNewMessages,
      alwaysNotifyByEmail: this.props.options.receiveEmailNotifications,
      notifyOnMentionOnly: this.props.options.receiveMentionEmailNotifications,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
  }

  togglePressEnterToSendMessage() {
    this.props.togglePressEnterToSendMessage();

    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      alwaysNotifyByEmail: this.props.options.receiveEmailNotifications,
      notifyOnMentionOnly: this.props.options.receiveMentionEmailNotifications,
      pressEnterToSendMessages: !this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
  }

  toggleReceiveEmailNotifications() {
    const newValue = !this.props.options.receiveEmailNotifications;

    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      alwaysNotifyByEmail: newValue,
      notifyOnMentionOnly: newValue
        ? false
        : this.props.options.receiveMentionEmailNotifications,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });

    this.props.toggleReceiveEmailNotifications();

    if (newValue && this.props.options.receiveMentionEmailNotifications) {
      this.props.toggleReceiveMentionEmailNotifications();
    }
  }

  toggleReceiveMentionEmailNotifications() {
    const newValue = !this.props.options.receiveMentionEmailNotifications;
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      alwaysNotifyByEmail: newValue
        ? false
        : this.props.options.receiveEmailNotifications,
      notifyOnMentionOnly: newValue,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });

    this.props.toggleReceiveMentionEmailNotifications();

    if (newValue && this.props.options.receiveEmailNotifications) {
      this.props.toggleReceiveEmailNotifications();
    }
  }

  render() {
    const {
      dynamicMessageFilter,
      alwaysOpenNewMessages,
      pressEnterToSendMessage,
      receiveEmailNotifications,
      receiveMentionEmailNotifications,
    } = this.props.options;

    return (
      <div className="general-settings">
        <span className="general-settings-section">
          <FormattedMessage id="settings.inbox" />
        </span>

        <div className="general-settings-option-container">
          <div className="general-settings-option-container-item">
            <span className="general-settings-option">
              <FormattedMessage id="settings.dynamicMessage" />

              <Switch
                defaultChecked={dynamicMessageFilter}
                onChange={this.toggleDynamicMessageFilter}
              />
            </span>

            <span className="general-settings-option-description">
              <FormattedMessage id="settings.dynamicMessage.description" />
            </span>
          </div>

          <div className="general-settings-option-container-item">
            <span className="general-settings-option">
              <FormattedMessage id="settings.alwaysOpenNewMessages" />
              <Switch
                defaultChecked={alwaysOpenNewMessages}
                onChange={this.toggleAlwaysOpenNewMessages}
              />
            </span>

            <span className="general-settings-option-description">
              <FormattedMessage id="settings.alwaysOpenNewMessages.description" />
            </span>
          </div>
        </div>

        <span className="general-settings-section">
          <FormattedMessage id="settings.sendMessage" />
        </span>

        <div className="general-settings-option-container">
          <div className="general-settings-option-container-item">
            <span className="general-settings-option">
              <FormattedMessage id="settings.pressEnterToSendMessage" />

              <Switch
                defaultChecked={pressEnterToSendMessage}
                onChange={this.togglePressEnterToSendMessage}
              />
            </span>

            <span className="general-settings-option-description">
              <FormattedMessage id="settings.pressEnterToSendMessage.description" />
            </span>
          </div>
        </div>

        <span className="general-settings-section">
          <FormattedMessage id="settings.notifications" />
        </span>

        <div className="general-settings-option-container">
          <span className="general-settings-option-header">
            <FormattedMessage id="settings.notifications.description" />
          </span>

          <div className="general-settings-option-container-item">
            <span className="general-settings-option">
              <FormattedMessage id="settings.receiveEmailNotifications" />

              <Switch
                checked={receiveEmailNotifications}
                onChange={this.toggleReceiveEmailNotifications}
              />
            </span>

            <span className="general-settings-option-description">
              <FormattedMessage id="settings.receiveEmailNotifications.description" />
            </span>
          </div>

          <div className="general-settings-option-container-item">
            <span className="general-settings-option">
              <FormattedMessage id="settings.receiveMentionEmailNotifications" />

              <Switch
                checked={receiveMentionEmailNotifications}
                onChange={this.toggleReceiveMentionEmailNotifications}
              />
            </span>

            <span className="general-settings-option-description">
              <FormattedMessage id="settings.receiveMentionEmailNotifications.description" />
            </span>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    options: state.GeneralSettings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleDynamicMessageFilter: (status) =>
    dispatch(toggleDynamicMessageFilter()),
  toggleAlwaysOpenNewMessages: (status) =>
    dispatch(toggleAlwaysOpenNewMessages()),
  togglePressEnterToSendMessage: (status) =>
    dispatch(togglePressEnterToSendMessage()),
  toggleReceiveEmailNotifications: (status) =>
    dispatch(toggleReceiveEmailNotifications()),
  toggleReceiveMentionEmailNotifications: (status) =>
    dispatch(toggleReceiveMentionEmailNotifications()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeneralSettings);
